const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 508 508",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#84DBFF"
    },
    cx: 254,
    cy: 254,
    r: 254
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M409.5,103.9h-311c-4.5,0-8.2,3.7-8.2,8.2v283.7c0,4.5,3.7,8.2,8.2,8.2h311c4.5,0,8.2-3.7,8.2-8.2 V112.2C417.7,107.6,414,103.9,409.5,103.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M417.7,169.1v-56.7c0-4.7-3.8-8.5-8.5-8.5H98.8c-4.7,0-8.5,3.8-8.5,8.5v56.7H417.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 230.6,
    y: 188,
    style: {
      fill: "#E6E9EE"
    },
    width: 46.7,
    height: 41.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.1,
    y: 188,
    style: {
      fill: "#E6E9EE"
    },
    width: 46.7,
    height: 41.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.6,
    y: 188,
    style: {
      fill: "#E6E9EE"
    },
    width: 46.7,
    height: 41.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.7,
    y: 240.9,
    style: {
      fill: "#E6E9EE"
    },
    width: 46.7,
    height: 41.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.2,
    y: 240.9,
    style: {
      fill: "#E6E9EE"
    },
    width: 46.7,
    height: 41.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.6,
    y: 240.9,
    style: {
      fill: "#E6E9EE"
    },
    width: 46.7,
    height: 41.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.1,
    y: 240.9,
    style: {
      fill: "#E6E9EE"
    },
    width: 46.7,
    height: 41.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.6,
    y: 240.9,
    style: {
      fill: "#E6E9EE"
    },
    width: 46.7,
    height: 41.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.7,
    y: 293.7,
    style: {
      fill: "#E6E9EE"
    },
    width: 46.7,
    height: 41.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.2,
    y: 293.7,
    style: {
      fill: "#E6E9EE"
    },
    width: 46.7,
    height: 41.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.6,
    y: 293.7,
    style: {
      fill: "#E6E9EE"
    },
    width: 46.7,
    height: 41.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.1,
    y: 293.7,
    style: {
      fill: "#E6E9EE"
    },
    width: 46.7,
    height: 41.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.6,
    y: 293.7,
    style: {
      fill: "#E6E9EE"
    },
    width: 46.7,
    height: 41.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.7,
    y: 346.5,
    style: {
      fill: "#E6E9EE"
    },
    width: 46.7,
    height: 41.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.2,
    y: 346.5,
    style: {
      fill: "#E6E9EE"
    },
    width: 46.7,
    height: 41.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.6,
    y: 346.5,
    style: {
      fill: "#E6E9EE"
    },
    width: 46.7,
    height: 41.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 356.8,
    cy: 136.5,
    r: 16.9
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 151.2,
    cy: 136.5,
    r: 16.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarSvgrepoCom);
export default __webpack_public_path__ + "static/media/calendar-svgrepo-com.348b61f877d1fdd2f7d3141c4bf4d098.svg";
export { ForwardRef as ReactComponent };